import angular from 'angular';

export default angular.module('components.catalogue', [])
   .value('CatalogueConfig', {
       catalogid: 1,
       facetsList: [
           {name: __("Author"), index: 'dc.creator', schema: 'zebra::facet::author:p:10'},
           {name: __("Subject heading"), index: 'dc.subject', schema: 'zebra::facet::subject-heading:p:10'},
           {name: __("Publisher"), index:'dc.publisher', schema: 'zebra::facet::publisher:p:10'},
           {name: __("Publication date"), index: 'dc.date', schema: 'zebra::facet::date-of-publication:w:10'},
           {name: __("Inventory"), index: 'cuba.999b', schema: 'zebra::facet::cuba-999-b:w:10'}
       ],
       rsnList: [
           //{name: __("Year of publication"), index: 'dc.date', query: 'cuba.dateNarrow=2021', schema: 'marcxml'},
       ]
    })
    .component('catalogue', {
        template: require('./catalogue.pug')(),
        controller: ['$state', 'CatalogueConfig', function($state, CatalogueConfig) {
            var ctrl = this;
            ctrl.$onInit = function() {
                ctrl.$state = $state;
                ctrl.catalogid = CatalogueConfig.catalogid;
                ctrl.facetsList= CatalogueConfig.facetsList;
                ctrl.rsnList= CatalogueConfig.rsnList;
            };
            ctrl.callAdvanced = function(state) {
                console.log('callAdvanced', state);
            }
        }]
    })
    .component('catalogueAdvanced', {
        template: require('./catalogueAdvanced.pug')(),
        controller: ['CatalogueConfig', function(CatalogueConfig) {
            var ctrl = this;
            ctrl.$onInit = function() {
                ctrl.catalogid = CatalogueConfig.catalogid;
                ctrl.facetsList= CatalogueConfig.facetsList;
                ctrl.rsnList= CatalogueConfig.rsnList;
            };
        }]
    })
    /*
    .component('catalogueDocument', {
        bindings: {
            id: '<'
        },
        template: require('./catalogueDocument.pug')(),
        controller: ['$state', 'ZebraService', 'CatalogueConfig', function($state, ZebraService, CatalogueConfig) {
            var ctrl = this;

            ctrl.$onInit = function() {
                ctrl.catalogid = CatalogueConfig.catalogid;
                ctrl.facetsList = CatalogueConfig.facetsList;
                ctrl.rsnList= CatalogueConfig.rsnList;
                ctrl.callSearch();
            };

            ctrl.callSearch = function() {
                var id =  ctrl.id.replace(/"/g, '\\"').replace(/\\/g, '\\\\');
                var query = 'rec.id="' + id + '"';
                var schema = ctrl.schemasList[0].value;

                ctrl.loading = true;
                search(ctrl.catalogid, query, schema, function(err, response) {
                    ctrl.loading = false;
                    if (err) {
                        ctrl.error = err.message || err;
                    }
                    ctrl.response = response;
                });
            };

            ////////

            function search(id, q, schema, done) {
                var params = {};
                params.id = id;
                params.operation = 'search';
                params.query = q;
                params.recordSchema = schema;
                console.log(params);
                ZebraService.get(params).$promise.then(function(response) {
                    done(null, response);
                }, function(err) {
                    done(err, null);
                });
            }

        }]
    })
    */
    .name; 
